import {Component, OnInit} from '@angular/core';
import {BannerBase} from '../banner-base';
import {DialogService} from '../../../../core/services/dialog.service';
import {BannersService} from '../../../services/banners.service';
import {AssetsService} from '../../../services/assets.service';

@Component({
    selector: 'app-driver-sos-details-banner',
    templateUrl: './driver-sos-details-banner.component.html',
    styleUrls: ['./driver-sos-details-banner.component.scss']
})
export class DriverSosDetailsBannerComponent extends BannerBase implements OnInit {

    get arrowUrl(): string {
        return `${this.assetsService.getBannersIconsDirectoryPath()}/arrow.svg`;
    }

    constructor(public dialogService: DialogService,
                public bannersService: BannersService,
                private assetsService: AssetsService) {
        super(dialogService);
    }

    ngOnInit() {
    }

}
